import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Masked identifier for the code screen.
 * - Phone: international format with its national grouping, the first national digit and the
 *   last three kept, everything else a bullet: "+974 5••• •940" (never "+9745 •••• 940").
 * - Email: first character of the local part, three bullets, the full domain: "m•••@hotmail.com".
 */
export function maskIdentifier(kind: 'phone' | 'email', value: string): string {
  if (kind === 'email') {
    const at = value.lastIndexOf('@');
    if (at <= 0) return value;
    return `${value.slice(0, 1)}•••${value.slice(at)}`;
  }
  const parsed = parsePhoneNumberFromString(value);
  if (!parsed) return value;
  const intl = parsed.formatInternational(); // "+974 5555 0940"
  const dial = `+${parsed.countryCallingCode}`;
  const national = intl.startsWith(dial) ? intl.slice(dial.length).trim() : intl;
  const digitCount = national.replace(/\D/g, '').length;
  let seen = 0;
  const masked = national.replace(/\d/g, (d) => {
    seen += 1;
    const keep = seen === 1 || seen > digitCount - 3;
    return keep ? d : '•';
  });
  return `${dial} ${masked}`;
}
